import { TQuery, TQueryConstructor } from '@hozana/api/types'
import { normalize } from '@hozana/redux/normalize'

import entities, { TRawPrayerMeeting } from 'config/entities'

import { TPrayerMeetingFormData } from './components/PrayerMeetingUpsert/PrayerMeetingUpsertInfos'
import { EPrayerMeetingStatus } from './constants'

type TPrayerMeetingOnlyProp = { prayerMeetingId: number; updateParametersToken: string }

export const getPrayerMeetingsQuery: TQueryConstructor<
  { prayerEventId: number; status: EPrayerMeetingStatus },
  number[]
> = ({ prayerEventId, status }) => ({
  queryKey: `getPrayerMeetings/${prayerEventId}`,
  url: `/prayer-meetings`,
  params: {
    prayerEventId,
    status,
  },
  method: 'GET',
  normalize: (data: TRawPrayerMeeting[]) => normalize(data, [entities.prayerMeeting]),
})
export const createPrayerMeetingMutation: TQueryConstructor<TPrayerMeetingFormData> = (prayerMeeting) => ({
  queryKey: `createPrayerMeeting`,
  url: `/prayer-meeting`,
  method: 'POST',
  params: prayerMeeting,
  normalize: (data: TRawPrayerMeeting) => ({
    result: data,
    entities: {
      prayerMeeting: normalize(data, entities.prayerMeeting),
    },
  }),
})

export const updatePrayerMeetingMutation: TQueryConstructor<TPrayerMeetingFormData> = (prayerMeeting) => ({
  queryKey: `updatePrayerMeeting`,
  url: `/prayer-meeting`,
  method: 'PATCH',
  params: prayerMeeting,
  normalize: (data: TRawPrayerMeeting) => ({
    result: data,
    entities: {
      prayerMeeting: normalize(data, entities.prayerMeeting),
    },
  }),
})

export const subscribeToPrayerMeetingMutation: TQueryConstructor<number> = (prayerMeetingId) => ({
  queryKey: `prayer-meeting/${prayerMeetingId}/subscribe`,
  url: `/prayer-meeting/${prayerMeetingId}/subscribe`,
  method: 'POST',
})

export const getPrayerMeetingQuery: TQueryConstructor<TPrayerMeetingOnlyProp, number> = ({
  prayerMeetingId,
  updateParametersToken,
}): TQuery => ({
  queryKey: `getPrayerMeeting?prayerMeetingId=${prayerMeetingId}&token=${updateParametersToken}`,
  url: `/prayer-meeting/${prayerMeetingId}`,
  method: 'GET',
  params: {
    token: updateParametersToken,
  },
  normalize: (data: TRawPrayerMeeting) => normalize(data, entities.prayerMeeting),
})
